import React from "react";
import styles from "./Medals.module.css";
import useTranslation from "next-translate/useTranslation";
import AllMedals from "../../components/common/all-medals";
import { useLeagues } from "../../redux/leagues";

export default function Medals() {
  const { t } = useTranslation("common");

  const {
    leagueScores,
    lastSeason,
    seasonNr,
    lastSeasonNr,
    hasMedals,
    hasLastSeason,
  } = useLeagues();

  return (
    <div className={styles.cont}>
      {hasMedals && (
        <>
          <div className={styles.seasonTitle}>
            {t("Season").toUpperCase()} {seasonNr}
          </div>
          <div className={styles.medalCont}>
            <AllMedals medalData={leagueScores} />
          </div>
        </>
      )}

      {hasLastSeason && (
        <>
          <div className={styles.seasonTitle}>
            {t("FINAL RESULT")} {t("Season").toUpperCase()} {lastSeasonNr}
          </div>
          <div className={styles.medalCont}>
            <AllMedals medalData={lastSeason} />
          </div>
        </>
      )}
    </div>
  );
}
